import './src/components/all.sass'

import wre from "./wrap-root-element"

export const wrapRootElement = wre
